import React, { Component } from 'react'
import '../index.css'; 
import back32 from '../Assets/back32.jpeg';
//import * as THREE from "three";
//import { gsap } from "gsap";
//import back10 from '../Assets/back10.svg';
//import back3 from '../Assets/back3.svg';
//import back2 from '../Assets/back2.jpeg';
export default class Home extends Component {
    render() {
        
        return (
            <div id="home-page" className="home-holder"> 
                
                {/*<h1 className="small-headline">Hello,</h1>
                <p className="small-headline-para">
                I am Nitin Kumar a full stack web developer, UI/UX framework designer also 
                a mobile application developer. You can get to know me more and contact me, 
                if you find me useful.
                </p>*/}
                <h1 className="small-headline-quote">"YOU OWN IT, YOU BETTER NEVER LET IT GO"</h1>
                    
                
                <img className="card__image " src={back32}/>
                
            </div>

        )
    }
}
